import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const communicationApi = createApi({
  reducerPath: 'communicationApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: [
    'Template',
    'TemplateList',
    'Festival',
    'FestivalList',
    'Calendar',
    'ProjectUpdate',
    'ProjectUpdateList',
    'CommSettings'
  ],
  endpoints: () => ({})
})

export default communicationApi
